import React from 'react'
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Text,
  Button,
  Input,
  Select,
  Icon,
  Card,
  CardBody,
} from "@chakra-ui/react";

import { LuCheckCircle, LuCreditCard, LuFileText, LuInfo, LuShield, LuBarChart, LuMessageCircle, LuTrendingUp } from 'react-icons/lu';

const TemplateManagerSstats = ({ stats }) => {
  if (!stats) return null; // or a Spinner while loading

  return (
    <div>
      {/* Top Summary Grid */}
      <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={6}>

        <Card>
          <Box p={5}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Text fontSize="sm" color="gray.500">
                  Total Templates
                </Text>
                <Text fontSize="2xl" fontWeight="semibold">
                  {stats?.totalTemplates}
                </Text>
              </Box>
              <LuFileText style={{ fontSize: "1.5rem", color: "blue" }} />
            </Box>
          </Box>
        </Card>


        <Card>
          <Box p={5}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Text fontSize="sm" color="gray.500">
                  Active Templates

                </Text>
                <Text fontSize="2xl" fontWeight="semibold">
                  {stats?.activeTemplate}
                </Text>
              </Box>
              <LuCheckCircle style={{ fontSize: "1.5rem", color: "green" }} />
            </Box>
          </Box>
        </Card>

        <Card>
          <Box p={5}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Text fontSize="sm" color="gray.500">
                  Total Usage

                </Text>
                <Text fontSize="2xl" fontWeight="semibold">
                  {stats?.totalUsage.toLocaleString()}
                </Text>
              </Box>
              <LuTrendingUp style={{ fontSize: "1.5rem", color: "purple" }} />
            </Box>
          </Box>
        </Card>
        <Card>
          <Box p={5}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Text fontSize="sm" color="gray.500">
                  Channels Supported

                </Text>
                <Text fontSize="2xl" fontWeight="semibold">
                  {stats?.channelSupport}
                </Text>
              </Box>
              <LuMessageCircle style={{ fontSize: "1.5rem", color: "orange" }} />
            </Box>
          </Box>
        </Card>



      </Grid>

      {/* Template Categories */}
      <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={6}>
        <Card bg="red.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="red.200" borderStyle="solid">
          <CardBody py={5}>
            <Flex justify="space-between" align="flex-start">
              <Flex direction="column" flex="1">
                <Flex align="center" mb={1}>
                  <Icon as={LuShield} color="red.500" fontSize="18px" mr={2} />
                  <Text fontWeight="600" fontSize="14px" color="gray.800">Authentication (OTP)</Text>
                </Flex>
                <Text fontSize="12px" color="gray.500" mb={0}>{stats?.authentication.usage} Total usage</Text>
                
              </Flex>
              <Text fontSize="32px" fontWeight="700" color="gray.800" lineHeight="1">
                {stats?.authentication.count}
              </Text>
            </Flex>
          </CardBody>
        </Card>

        <Card bg="green.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="green.200" borderStyle="solid">
          <CardBody py={5}>
            <Flex justify="space-between" align="flex-start">
              <Flex direction="column" flex="1">
                <Flex align="center" mb={1}>
                  <Icon as={LuCreditCard} color="green.500" fontSize="18px" mr={2} />
                  <Text fontWeight="600" fontSize="14px" color="gray.800">Transaction</Text>
                </Flex>
                <Text fontSize="12px" color="gray.500" mb={0}>{stats?.transaction.usage} Total usage</Text>
                
              </Flex>
              <Text fontSize="32px" fontWeight="700" color="gray.800" lineHeight="1">
                {stats?.transaction.count}
              </Text>
            </Flex>
          </CardBody>
        </Card>

        <Card bg="blue.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="blue.200" borderStyle="solid" >
          <CardBody py={5}>
            <Flex justify="space-between" align="flex-start">
              <Flex direction="column" flex="1">
                <Flex align="center" mb={1}>
                  <Icon as={LuInfo} color="blue.500" fontSize="18px" mr={2} />
                  <Text fontWeight="600" fontSize="14px" color="gray.800">Informational</Text>
                </Flex>
                <Text fontSize="12px" color="gray.500" mb={0}>{stats?.information.usage} Total usage</Text>
                
              </Flex>
              <Text fontSize="32px" fontWeight="700" color="gray.800" lineHeight="1">
                {stats?.information.count}
              </Text>
            </Flex>
          </CardBody>
        </Card>

        <Card bg="purple.50" boxShadow="sm" borderRadius="lg"  border={1} borderColor="purple.200" borderStyle="solid" >
          <CardBody py={5}>
            <Flex justify="space-between" align="flex-start">
              <Flex direction="column" flex="1">
                <Flex align="center" mb={1}>
                  <Icon as={LuBarChart} color="purple.500" fontSize="18px" mr={2} />
                  <Text fontWeight="600" fontSize="14px" color="gray.800">Marketing</Text>
                </Flex>
                <Text fontSize="12px" color="gray.500" mb={0}>{stats.marketing.usage} Total usage</Text>
                
              </Flex>
              <Text fontSize="32px" fontWeight="700" color="gray.800" lineHeight="1">
                {stats.marketing.count}
              </Text>
            </Flex>
          </CardBody>
        </Card>
      </Grid>
    </div>
  );
};

export default TemplateManagerSstats